module.exports = __webpack_public_path__ + "static/media/Costbanner.02c6ccc3.png";